/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PromosRouteImport } from './routes/promos'
import { Route as PlansRouteImport } from './routes/plans'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as OpsRouteImport } from './routes/ops'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as CohortsRouteImport } from './routes/cohorts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WithdrawalsIdRouteImport } from './routes/withdrawals.$id'
import { Route as PartnersIdRouteImport } from './routes/partners.$id'
import { Route as ClientsIdRouteImport } from './routes/clients.$id'
import { Route as BotsIdRouteImport } from './routes/bots.$id'

const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const PromosRoute = PromosRouteImport.update({
  id: '/promos',
  path: '/promos',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsRoute = OpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const CohortsRoute = CohortsRouteImport.update({
  id: '/cohorts',
  path: '/cohorts',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WithdrawalsIdRoute = WithdrawalsIdRouteImport.update({
  id: '/withdrawals/$id',
  path: '/withdrawals/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIdRoute = PartnersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PartnersRoute,
} as any)
const ClientsIdRoute = ClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BotsIdRoute = BotsIdRouteImport.update({
  id: '/bots/$id',
  path: '/bots/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cohorts': typeof CohortsRoute
  '/finance': typeof FinanceRoute
  '/ops': typeof OpsRoute
  '/partners': typeof PartnersRouteWithChildren
  '/plans': typeof PlansRoute
  '/promos': typeof PromosRoute
  '/search': typeof SearchRoute
  '/bots/$id': typeof BotsIdRoute
  '/clients/$id': typeof ClientsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/withdrawals/$id': typeof WithdrawalsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cohorts': typeof CohortsRoute
  '/finance': typeof FinanceRoute
  '/ops': typeof OpsRoute
  '/partners': typeof PartnersRouteWithChildren
  '/plans': typeof PlansRoute
  '/promos': typeof PromosRoute
  '/search': typeof SearchRoute
  '/bots/$id': typeof BotsIdRoute
  '/clients/$id': typeof ClientsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/withdrawals/$id': typeof WithdrawalsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cohorts': typeof CohortsRoute
  '/finance': typeof FinanceRoute
  '/ops': typeof OpsRoute
  '/partners': typeof PartnersRouteWithChildren
  '/plans': typeof PlansRoute
  '/promos': typeof PromosRoute
  '/search': typeof SearchRoute
  '/bots/$id': typeof BotsIdRoute
  '/clients/$id': typeof ClientsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/withdrawals/$id': typeof WithdrawalsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cohorts'
    | '/finance'
    | '/ops'
    | '/partners'
    | '/plans'
    | '/promos'
    | '/search'
    | '/bots/$id'
    | '/clients/$id'
    | '/partners/$id'
    | '/withdrawals/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cohorts'
    | '/finance'
    | '/ops'
    | '/partners'
    | '/plans'
    | '/promos'
    | '/search'
    | '/bots/$id'
    | '/clients/$id'
    | '/partners/$id'
    | '/withdrawals/$id'
  id:
    | '__root__'
    | '/'
    | '/cohorts'
    | '/finance'
    | '/ops'
    | '/partners'
    | '/plans'
    | '/promos'
    | '/search'
    | '/bots/$id'
    | '/clients/$id'
    | '/partners/$id'
    | '/withdrawals/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CohortsRoute: typeof CohortsRoute
  FinanceRoute: typeof FinanceRoute
  OpsRoute: typeof OpsRoute
  PartnersRoute: typeof PartnersRouteWithChildren
  PlansRoute: typeof PlansRoute
  PromosRoute: typeof PromosRoute
  SearchRoute: typeof SearchRoute
  BotsIdRoute: typeof BotsIdRoute
  ClientsIdRoute: typeof ClientsIdRoute
  WithdrawalsIdRoute: typeof WithdrawalsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promos': {
      id: '/promos'
      path: '/promos'
      fullPath: '/promos'
      preLoaderRoute: typeof PromosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops': {
      id: '/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof OpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cohorts': {
      id: '/cohorts'
      path: '/cohorts'
      fullPath: '/cohorts'
      preLoaderRoute: typeof CohortsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/withdrawals/$id': {
      id: '/withdrawals/$id'
      path: '/withdrawals/$id'
      fullPath: '/withdrawals/$id'
      preLoaderRoute: typeof WithdrawalsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/$id': {
      id: '/partners/$id'
      path: '/$id'
      fullPath: '/partners/$id'
      preLoaderRoute: typeof PartnersIdRouteImport
      parentRoute: typeof PartnersRoute
    }
    '/clients/$id': {
      id: '/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof ClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bots/$id': {
      id: '/bots/$id'
      path: '/bots/$id'
      fullPath: '/bots/$id'
      preLoaderRoute: typeof BotsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface PartnersRouteChildren {
  PartnersIdRoute: typeof PartnersIdRoute
}

const PartnersRouteChildren: PartnersRouteChildren = {
  PartnersIdRoute: PartnersIdRoute,
}

const PartnersRouteWithChildren = PartnersRoute._addFileChildren(
  PartnersRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CohortsRoute: CohortsRoute,
  FinanceRoute: FinanceRoute,
  OpsRoute: OpsRoute,
  PartnersRoute: PartnersRouteWithChildren,
  PlansRoute: PlansRoute,
  PromosRoute: PromosRoute,
  SearchRoute: SearchRoute,
  BotsIdRoute: BotsIdRoute,
  ClientsIdRoute: ClientsIdRoute,
  WithdrawalsIdRoute: WithdrawalsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
